import { format, parseISO } from 'swipeclock-frontend';
import { OFFLINE_PUNCH_LABELS } from '../constants/offlinePunchLabels';

export const formatOfflinePunchDateHeader = (punchDateTime) => {
  if (!punchDateTime) {
    return '';
  }

  const date = parseISO(punchDateTime);
  return format(date, 'EEEE - MMMM d, yyyy');
};

export const getOfflinePunchLabel = (punch) =>
  OFFLINE_PUNCH_LABELS[punch] || punch || 'Unknown punch';

const comparePunchDateTime = (left, right) =>
  new Date(left.punchDateTime) - new Date(right.punchDateTime);

export const groupOfflinePunchesByDate = (items) => {
  if (!items?.length) {
    return [];
  }

  const sortedItems = [...items].sort(comparePunchDateTime);
  const groups = [];

  sortedItems.forEach((item) => {
    const dateHeader = formatOfflinePunchDateHeader(item.punchDateTime);
    const lastGroup = groups[groups.length - 1];

    if (lastGroup?.dateHeader === dateHeader) {
      lastGroup.punches.push(item);
      return;
    }

    groups.push({
      dateHeader,
      punches: [item],
    });
  });

  return groups;
};
